import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, MapPinIcon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
const FIRST_DELAY = 5000;
const VISIBLE_MS = 6000;
const HIDDEN_MS = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const timeout = window.setTimeout(() => {
      if (visible) {
        setVisible(false);
        setIndex(prev => (prev + 1) % recentBuyers.length);
      } else {
        setVisible(true);
      }
    }, visible ? VISIBLE_MS : index === 0 ? FIRST_DELAY : HIDDEN_MS);
    return () => window.clearTimeout(timeout);
  }, [visible, index, dismissed]);
  const buyer = recentBuyers[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-3 left-3 z-50 max-w-[16.5rem]" data-id="element-119" data-mp="1gx2t254uzpug">
      <AnimatePresence data-id="element-120" data-mp="163mmh36s5qw3">
        {visible && !dismissed && <motion.div key={buyer.name} initial={{
        opacity: 0,
        y: 12,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.97
      }} transition={{
        duration: 0.25,
        ease: EASE
      }} className="pointer-events-auto flex items-start gap-2 rounded-xl border-2 border-navy bg-energy p-2.5 shadow-xl shadow-navy/30 ring-[3px] ring-spark" data-id="element-121" data-mp="1164o26qe2u2c">
            <span className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-electric ring-2 ring-white" data-id="element-122" data-mp="x5b1bgoonlb1">
              <CheckIcon size={13} aria-hidden="true" className="text-white" strokeWidth={3} data-id="element-123" data-mp="s56gjegqs4f0" />
            </span>
            <div className="min-w-0" data-id="element-124" data-mp="28j4yafbt620w">
              <p className="font-display text-[0.72rem] font-extrabold leading-snug text-navy" data-id="element-125" data-mp="28mara5nk5o1w">
                {buyer.name} compró el Mega Pack Profesor Técnico ⚡
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-[0.65rem] font-semibold text-navy/80" data-id="element-126" data-mp="2aobbih2afotc">
                <MapPinIcon size={10} aria-hidden="true" className="flex-shrink-0" data-id="element-127" data-mp="2fpqzagvuo9ff" />
                {buyer.city}, {buyer.country} · hace {buyer.minutes} min
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar aviso" className="flex-shrink-0 rounded p-0.5 text-navy/70 transition-colors duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:text-navy" data-id="element-128" data-mp="2pl2f72izvmor">
              <XIcon size={13} data-id="element-129" data-mp="21uyaeru2lgw6" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}